import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { findUser, modifyUser, findSetting, updateAlertSetting, listDevice, updateTermSetting } from '../_actions/user_action';

import '../css/Header.css';
import '../css/Body.css';

import {
    Box,
    Button,
    Stack,
    Grid,
    TextField,
    Typography,
    Checkbox,
    FormControlLabel,
    Modal,
} from '@mui/material';

// 콤보박스추가
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import { getUserAccount, getIsLogin } from '../utils/session';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

// Modal
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 600,
    bgcolor: 'background.paper',
    borderRadius: '16px',
    border: 'none',
    boxShadow: 14,
    p: 4
};

function MobileSettingAlarm() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userAccount = getUserAccount() || {};
    const isLogin = getIsLogin();

    const [isReady, setIsReady] = useState(false);
    const [userInfo, setUserInfo] = useState();
    const [settingInfo, setSettingInfo] = useState();

    useEffect(() => {
        if (!isLogin || !userAccount) {
            navigate('/mobile');
            return;
        }

        let body = {
            email: userAccount.email
        };

        dispatch(findUser(body)).then(response => {
            // console.log('findUser', response.payload);
            
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                if (userInfo) {
                    setUserInfo(userInfo);

                    body = {
                        id: userAccount.email,
                        sensorMain: userAccount.sensorMain
                    };
    
                    dispatch(findSetting(body)).then(response => {
                        console.log('findSetting', response.payload);

                        if (response.payload.findSuccess) {
                            let settingInfo = response.payload.settingInfo;
                            if (settingInfo) {
                                setSettingInfo(settingInfo);
                                if (settingInfo.opLightLampNH3 === 1) {
                                    setCheckedLightLampNH3(true);
                                }
                                if (settingInfo.opSNSPushNH3 === 1) {
                                    setCheckedSNSPushNH3(true);
                                }
                                if (settingInfo.opLightLampH2S === 1) {
                                    setCheckedLightLampH2S(true);
                                }
                                if (settingInfo.opSNSPushH2S === 1) {
                                    setCheckedSNSPushH2S(true);
                                }
                                setInputsModifyAlert({
                                    modifyMoeLimitNH3: settingInfo.moeLimitNH3,
                                    modifyUserLimitNH3: settingInfo.userLimitNH3.length === 0 ? settingInfo.moeLimitNH3 : settingInfo.userLimitNH3,
                                    modifyOpLightLampNH3: settingInfo.opLightLampNH3,
                                    modifyOpSNSPushNH3: settingInfo.opSNSPushNH3,
                                    modifyMoeLimitH2S: settingInfo.moeLimitH2S,
                                    modifyUserLimitH2S: settingInfo.userLimitH2S.length === 0 ? settingInfo.moeLimitH2S : settingInfo.userLimitH2S,
                                    modifyOpLightLampH2S: settingInfo.opLightLampH2S,
                                    modifyOpSNSPushH2S: settingInfo.opSNSPushH2S
                                });
                                setModifyUserTerm(settingInfo.userTerm);
                                setIsReady(true);
                            }
                        }
                    })
                    .catch((err) => console.log(err));
                }
            }
        })
        .catch((err) => console.log(err));
    }, []);

    const focusRefModifyMoeLimitNH3 = useRef();
    const focusRefModifyUserLimitNH3 = useRef();
    const focusRefModifyMoeLimitH2S = useRef();
    const focusRefModifyUserLimitH2S = useRef();

    const [inputsModifyAlert, setInputsModifyAlert] = useState({
        modifyMoeLimitNH3: "25",
        modifyUserLimitNH3: "15",
        modifyMoeLimitH2S: "10",
        modifyUserLimitH2S: "6"
    });

    const {
        modifyMoeLimitNH3,
        modifyUserLimitNH3,
        modifyMoeLimitH2S,
        modifyUserLimitH2S
    } = inputsModifyAlert;

    const [checkedLightLampNH3, setCheckedLightLampNH3] = useState(false);
    const [checkedSNSPushNH3, setCheckedSNSPushNH3] = useState(false);
    const [checkedLightLampH2S, setCheckedLightLampH2S] = useState(false);
    const [checkedSNSPushH2S, setCheckedSNSPushH2S] = useState(false);

    const handleChangeModifyAlert = (e) => {
        console.log(e.target.name, e.target.value);

        const regex = /^\d+\.\d{2}$/;
        if (e.target.name === 'modifyMoeLimitNH3' || e.target.name === 'modifyUserLimitNH3' || e.target.name === 'modifyMoeLimitH2S' || e.target.name === 'modifyUserLimitH2S') {
            // if (!regex.test(e.target.value))
                // return;
        }

        const { value, name } = e.target;
        setInputsModifyAlert({
            ...inputsModifyAlert,
            [name]: value
        });
    };

    const handleChange_LightLamp_NH3 = (e) => {
        setCheckedLightLampNH3(e.target.checked);
    };

    const handleChange_SNSPush_NH3 = (e) => {
        setCheckedSNSPushNH3(e.target.checked);
    };
    
    const handleChange_LightLamp_H2S = (e) => {
        setCheckedLightLampH2S(e.target.checked);
    };

    const handleChange_SNSPush_H2S = (e) => {
        setCheckedSNSPushH2S(e.target.checked);
    };

    const handleModifySubmitAlert = (e) => {
        e.preventDefault();
        
        let modify_key = "";
        let modify_errors = "";
    
        const changeAlertSetting = {
            id: settingInfo.id,
            sensorMain: settingInfo.sensorMain,
            moeLimitNH3: modifyMoeLimitNH3,
            moeLimitH2S: modifyMoeLimitH2S,
            userLimitNH3: modifyUserLimitNH3,
            userLimitH2S: modifyUserLimitH2S
        };
    
        for (var key in changeAlertSetting) {
            modify_errors = "";
    
            if (changeAlertSetting[key].length === 0 || changeAlertSetting[key] === undefined) {
                modify_key = key;
    
                if (key === 'moeLimitNH3') {
                    modify_errors = "암모니아 - [환경부 허용치]가 없습니다.";
                } else if (key === 'moeLimitH2S') {
                    modify_errors = "황화수소 - [환경부 허용치]가 없습니다.";
                } else if (key === 'userLimitNH3') {
                    modify_errors = "암모니아 - [사용자 기준치]가 없습니다.";
                } else if (key === 'userLimitH2S') {
                    modify_errors = "황화수소 - [사용자 기준치]가 없습니다.";
                }
            }
    
            if (modify_errors.length > 1)
                break;
        }
    
        if (modify_errors.length > 1) {
            alert(modify_errors);
    
            if (modify_key === 'moeLimitNH3') {
                focusRefModifyMoeLimitNH3.current.focus();
            } else if (modify_key === 'moeLimitH2S') {
                focusRefModifyMoeLimitH2S.current.focus();
            } else if (modify_key === 'userLimitNH3') {
                focusRefModifyUserLimitNH3.current.focus();
            } else if (modify_key === 'userLimitH2S') {
                focusRefModifyUserLimitH2S.current.focus();
            }
    
            return;
        }
    
        // 암모니아
        // 환경부 허용치
        if (!(modifyMoeLimitNH3.length === 2)) {
            modify_errors = "암모니아 - 환경부 허용치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                moeLimitNH3: ""
            });
            focusRefModifyMoeLimitNH3.current.focus();
            return;
        }
        // 사용자 기준치
        if (!(modifyUserLimitNH3.length === 2)) {
            modify_errors = "암모니아 - 사용자 기준치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                userLimitNH3: ""
            });
            focusRefModifyUserLimitNH3.current.focus();
            return;
        }
    
        // 황화수소
        // 환경부 허용치
        if (!(modifyMoeLimitH2S.length === 2)) {
            modify_errors = "황화수소 - 환경부 허용치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                moeLimitH2S: ""
            });
            focusRefModifyMoeLimitH2S.current.focus();
            return;
        }
        // 사용자 기준치
        if (!(modifyUserLimitH2S.length === 2)) {
            modify_errors = "황화수소 - 사용자 기준치 값을 정수 2자리로 정확하게 입력해주세요.";
            alert(modify_errors);
            setInputsModifyAlert({
                ...inputsModifyAlert,
                userLimitH2S: ""
            });
            focusRefModifyUserLimitH2S.current.focus();
            return;
        }
    
        let message = "경고설정을 수정하시겠습니까?";
        if (!window.confirm(message))
            return;
    
        let body = {
            id: settingInfo.id,
            sensorMain: settingInfo.sensorMain,
            moeLimitNH3: modifyMoeLimitNH3,
            moeLimitH2S: modifyMoeLimitH2S,
            userLimitNH3: modifyUserLimitNH3,
            userLimitH2S: modifyUserLimitH2S,
            opLightLampNH3: checkedLightLampNH3 ? 1 : 0,
            opLightLampH2S: checkedLightLampH2S ? 1 : 0,
            opSNSPushNH3: checkedSNSPushNH3 ? 1 : 0,
            opSNSPushH2S: checkedSNSPushH2S ? 1 : 0
        };
    
        let modify_msg = "";
    
        console.log('findSetting', body);
        dispatch(findSetting(body)).then(response => {
            if (response.payload.findSuccess) {
                console.log('updateAlertSetting', body);
                dispatch(updateAlertSetting(body)).then(response => {
                    if (response.payload.updateSuccess) {
                        modify_msg = "[" + settingInfo.id + " (" + userAccount.company + ")] 경고설정 수정 되었습니다.";
                        alert(modify_msg);
                        window.location.replace('/Setting');
                    }
                });
            }
        });
    };

    const [deviceListInfo, setDeviceListInfo] = useState([]);

    useEffect(() => {
        let body = {
            id: userAccount.email
        };
    
        dispatch(listDevice(body)).then(response => {
            if (response.payload.listSuccess) {
                let deviceList = response.payload.deviceList;
                setDeviceListInfo(deviceList);
            }
        });
    }, []);

    const [modifyUserTerm, setModifyUserTerm] = useState(10);

    return (
        <>
        <Box sx={{ width: '100%', mx: 'auto', overflowX: 'auto' }}>
            {/* 1) 첫 열: 항목 레이블 */}
            <Box
                component="ul"
                sx={{
                    display: 'flex',
                    m: 0,
                    p: 0,
                    listStyle: 'none',
                    minWidth: 270,
                }}
            >
                <Box
                    component="li"
                    sx={{
                        flex: 1,
                        minWidth: 90,
                        textAlign: 'center',
                        py: 1,
                        fontWeight: 'bold',
                    }}
                >
                
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    암모니아
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    황화수소
                </Box>
            </Box>
        
            {/* 2) 환경부 허용치 */}
            <Box
                component="ul"
                sx={{
                    display: 'flex',
                    m: 0,
                    p: 0,
                    listStyle: 'none',
                    minWidth: 270,
                }}
            >
                <Box
                    component="li"
                    sx={{
                        flex: 1,
                        minWidth: 90,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        py: 1
                    }}
                >
                    환경부<br />허용치<br />(ppm)
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <TextField
                        id="modifyMoeLimitNH3"
                        name="modifyMoeLimitNH3"
                        value={modifyMoeLimitNH3}
                        inputRef={focusRefModifyMoeLimitNH3}
                        onChange={handleChangeModifyAlert}
                        size="small"
                        inputProps={{ maxLength: 3, style: { textAlign: 'center' } }}
                        sx={{ width: '80%' }}
                    />
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <TextField
                        id="modifyMoeLimitH2S"
                        name="modifyMoeLimitH2S"
                        value={modifyMoeLimitH2S}
                        inputRef={focusRefModifyMoeLimitH2S}
                        onChange={handleChangeModifyAlert}
                        size="small"
                        inputProps={{ maxLength: 3, style: { textAlign: 'center' } }}
                        sx={{ width: '80%' }}
                    />
                </Box>
            </Box>
        
            {/* 3) 사용자 기준치 */}
            <Box
                component="ul"
                sx={{
                    display: 'flex',
                    m: 0,
                    p: 0,
                    listStyle: 'none',
                    minWidth: 270,
                }}
            >
                <Box
                    component="li"
                    sx={{
                        flex: 1,
                        minWidth: 90,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        py: 1
                    }}
                >
                    사용자<br />기준치<br />(ppm)
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <TextField
                        id="modifyUserLimitNH3"
                        name="modifyUserLimitNH3"
                        value={modifyUserLimitNH3}
                        inputRef={focusRefModifyUserLimitNH3}
                        onChange={handleChangeModifyAlert}
                        size="small"
                        inputProps={{ maxLength: 3, style: { textAlign: 'center' } }}
                        sx={{ width: '80%' }}
                    />
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <TextField
                        id="modifyUserLimitH2S"
                        name="modifyUserLimitH2S"
                        value={modifyUserLimitH2S}
                        inputRef={focusRefModifyUserLimitH2S}
                        onChange={handleChangeModifyAlert}
                        size="small"
                        inputProps={{ maxLength: 3, style: { textAlign: 'center' } }}
                        sx={{ width: '80%' }}
                    />
                </Box>
            </Box>
        
            {/* 4) 경고음 발생 */}
            <Box
                component="ul"
                sx={{
                    display: 'flex',
                    m: 0,
                    p: 0,
                    listStyle: 'none',
                    minWidth: 270,
                }}
            >
                <Box
                    component="li"
                    sx={{
                        flex: 1,
                        minWidth: 90,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        py: 1
                    }}
                >
                    경고음<br />발생
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <Checkbox
                        {...label}
                        checked={checkedLightLampNH3}
                        onChange={handleChange_LightLamp_NH3}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                    />
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <Checkbox
                        {...label}
                        checked={checkedLightLampH2S}
                        onChange={handleChange_LightLamp_H2S}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                    />
                </Box>
            </Box>
        
            {/* 5) SNS 알림 */}
            <Box
                component="ul"
                sx={{
                    display: 'flex',
                    m: 0,
                    p: 0,
                    listStyle: 'none',
                    minWidth: 270,
                }}
            >
                <Box
                    component="li"
                    sx={{
                        flex: 1,
                        minWidth: 90,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        py: 1
                    }}
                >
                    SNS<br />알림
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <Checkbox
                        {...label}
                        checked={checkedSNSPushNH3}
                        onChange={handleChange_SNSPush_NH3}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                    />
                </Box>
                <Box component="li" sx={{ flex: 1, minWidth: 90, textAlign: 'center', py: 1 }}>
                    <Checkbox
                        {...label}
                        checked={checkedSNSPushH2S}
                        onChange={handleChange_SNSPush_H2S}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                    />
                </Box>
            </Box>
        </Box>
        
        <Box sx={{  display: 'flex', justifyContent: 'center', mt: 2, width: '100%' }}>
            <Button
                variant="contained"
                onClick={handleModifySubmitAlert}
                sx={{
                    backgroundColor: '#4e82eb',
                    color: 'white',
                    px: 4,
                    borderRadius: 1,
                }}
            >
                수 정
            </Button>
        </Box>
        </>
    );      
}

export default MobileSettingAlarm;
